import { __assign } from "tslib";
export var defaultFontTokens = {
    primaryFontFamily: 'system-ui, "Helvetica Neue", Helvetica, Arial, sans-serif',
};
var monoFontFamily = '"Lucida Console", Monaco, monospace';
export default (function (fontTokens) {
    if (fontTokens === void 0) { fontTokens = defaultFontTokens; }
    var font100 = {
        fontFamily: fontTokens.primaryFontFamily,
        fontSize: '12px',
        fontWeight: 'normal',
        lineHeight: '20px',
    };
    var font150 = {
        fontFamily: fontTokens.primaryFontFamily,
        fontSize: '12px',
        fontWeight: 500,
        lineHeight: '16px',
    };
    var font200 = {
        fontFamily: fontTokens.primaryFontFamily,
        fontSize: '14px',
        fontWeight: 'normal',
        lineHeight: '20px',
    };
    var font250 = {
        fontFamily: fontTokens.primaryFontFamily,
        fontSize: '14px',
        fontWeight: 500,
        lineHeight: '16px',
    };
    var font300 = {
        fontFamily: fontTokens.primaryFontFamily,
        fontSize: '16px',
        fontWeight: 'normal',
        lineHeight: '24px',
    };
    var font350 = {
        fontFamily: fontTokens.primaryFontFamily,
        fontSize: '16px',
        fontWeight: 500,
        lineHeight: '20px',
    };
    var font400 = {
        fontFamily: fontTokens.primaryFontFamily,
        fontSize: '18px',
        fontWeight: 'normal',
        lineHeight: '28px',
    };
    var font450 = {
        fontFamily: fontTokens.primaryFontFamily,
        fontSize: '18px',
        fontWeight: 500,
        lineHeight: '24px',
    };
    var font550 = {
        fontFamily: fontTokens.primaryFontFamily,
        fontSize: '20px',
        fontWeight: 700,
        lineHeight: '28px',
    };
    var font650 = {
        fontFamily: fontTokens.primaryFontFamily,
        fontSize: '24px',
        fontWeight: 700,
        lineHeight: '32px',
    };
    var font750 = {
        fontFamily: fontTokens.primaryFontFamily,
        fontSize: '28px',
        fontWeight: 700,
        lineHeight: '36px',
    };
    var font850 = {
        fontFamily: fontTokens.primaryFontFamily,
        fontSize: '32px',
        fontWeight: 700,
        lineHeight: '40px',
    };
    var font950 = {
        fontFamily: fontTokens.primaryFontFamily,
        fontSize: '36px',
        fontWeight: 700,
        lineHeight: '44px',
    };
    var font1050 = {
        fontFamily: fontTokens.primaryFontFamily,
        fontSize: '40px',
        fontWeight: 700,
        lineHeight: '52px',
    };
    var font1150 = {
        fontFamily: fontTokens.primaryFontFamily,
        fontSize: '36px',
        fontWeight: 700,
        lineHeight: '44px',
    };
    var font1250 = {
        fontFamily: fontTokens.primaryFontFamily,
        fontSize: '44px',
        fontWeight: 700,
        lineHeight: '52px',
    };
    var font1350 = {
        fontFamily: fontTokens.primaryFontFamily,
        fontSize: '52px',
        fontWeight: 700,
        lineHeight: '64px',
    };
    var font1450 = {
        fontFamily: fontTokens.primaryFontFamily,
        fontSize: '96px',
        fontWeight: 700,
        lineHeight: '112px',
    };
    return {
        font100: font100,
        font150: font150,
        font200: font200,
        font250: font250,
        font300: font300,
        font350: font350,
        font400: font400,
        font450: font450,
        font550: font550,
        font650: font650,
        font750: font750,
        font850: font850,
        font950: font950,
        font1050: font1050,
        font1150: font1150,
        font1250: font1250,
        font1350: font1350,
        font1450: font1450,
        ParagraphXSmall: font100,
        ParagraphSmall: font200,
        ParagraphMedium: font300,
        ParagraphLarge: font400,
        LabelXSmall: font150,
        LabelSmall: font250,
        LabelMedium: font350,
        LabelLarge: font450,
        HeadingXSmall: font550,
        HeadingSmall: font650,
        HeadingMedium: font750,
        HeadingLarge: font850,
        HeadingXLarge: font950,
        HeadingXXLarge: font1050,
        DisplayXSmall: font1150,
        DisplaySmall: font1250,
        DisplayMedium: font1350,
        DisplayLarge: font1450,
        MonoParagraphXSmall: __assign(__assign({}, font100), { fontFamily: monoFontFamily }),
        MonoParagraphSmall: __assign(__assign({}, font200), { fontFamily: monoFontFamily }),
        MonoParagraphMedium: __assign(__assign({}, font300), { fontFamily: monoFontFamily }),
        MonoParagraphLarge: __assign(__assign({}, font400), { fontFamily: monoFontFamily }),
        MonoLabelXSmall: __assign(__assign({}, font150), { fontFamily: monoFontFamily }),
        MonoLabelSmall: __assign(__assign({}, font250), { fontFamily: monoFontFamily }),
        MonoLabelMedium: __assign(__assign({}, font350), { fontFamily: monoFontFamily }),
        MonoLabelLarge: __assign(__assign({}, font450), { fontFamily: monoFontFamily }),
        MonoHeadingXSmall: __assign(__assign({}, font550), { fontFamily: monoFontFamily }),
        MonoHeadingSmall: __assign(__assign({}, font650), { fontFamily: monoFontFamily }),
        MonoHeadingMedium: __assign(__assign({}, font750), { fontFamily: monoFontFamily }),
        MonoHeadingLarge: __assign(__assign({}, font850), { fontFamily: monoFontFamily }),
        MonoHeadingXLarge: __assign(__assign({}, font950), { fontFamily: monoFontFamily }),
        MonoHeadingXXLarge: __assign(__assign({}, font1050), { fontFamily: monoFontFamily }),
        MonoDisplayXSmall: __assign(__assign({}, font1150), { fontFamily: monoFontFamily }),
        MonoDisplaySmall: __assign(__assign({}, font1250), { fontFamily: monoFontFamily }),
        MonoDisplayMedium: __assign(__assign({}, font1350), { fontFamily: monoFontFamily }),
        MonoDisplayLarge: __assign(__assign({}, font1450), { fontFamily: monoFontFamily }),
    };
});
